import styled from 'styled-components';

export const StyleLayout = styled.div`
  background-color: #f2f4f7;
  min-width: 1100px;
`;
